import React from "react";
import SearchBar from "../../../common/filters/SearchBar";
import downloadCloud from "../../../assets/download-cloud-02.svg";
import {
  FiltersSection,
  FiltersRight,
  ExportButton,
  FilterExportText,
} from "../../allOrdersManagement/OrderDetails.styles";
import SortBy from "../../../common/filters/SortBy";
import CustomDateRangePicker from "../../../pages/selller/dashboards/components/custom-date-range";
import { Box } from "@mui/material";
import { dateRangeSortWrapperStyle } from "../../ledger/ledgerStyles";
import { useOutsideClose } from "../../../hooks/useOutsideClose";

interface FiltersProps {
  searchTerm: string;
  handleSearch: (e: React.ChangeEvent<HTMLInputElement>) => void;
  sortBy: string;
  setSortBy: React.Dispatch<React.SetStateAction<string>>;
  from: Date | undefined;
  to: Date | undefined;
  setFrom: React.Dispatch<React.SetStateAction<Date | undefined>>;
  setTo: React.Dispatch<React.SetStateAction<Date | undefined>>;
  handleExport: () => void;
  sortOptions: string[];
}

const CreditNotesFilters: React.FC<FiltersProps> = ({
  searchTerm,
  handleSearch,
  sortBy,
  setSortBy,
  from,
  to,
  setFrom,
  setTo,
  handleExport,
  sortOptions,
}) => {
  const [openFilter, setOpenFilter] = React.useState<"sort" | "date" | null>(
    null
  );
  const filterContainerRef = React.useRef<HTMLDivElement>(null);

  useOutsideClose(filterContainerRef, openFilter !== null, () =>
    setOpenFilter(null)
  );

  const enhancedWrapperStyle = {
    ...dateRangeSortWrapperStyle,
    position: "relative" as const,
    zIndex: openFilter === "date" ? 998 : undefined,
  };

  return (
    <FiltersSection>
      <SearchBar handleSearch={handleSearch} searchTerm={searchTerm} />

      <FiltersRight>
        <Box ref={filterContainerRef} sx={enhancedWrapperStyle}>
          <SortBy
            selected={sortBy}
            options={sortOptions}
            setSelected={setSortBy}
            variant="seller"
            hideOptions
            isOpen={openFilter === "sort"}
            onToggle={(open: boolean) => setOpenFilter(open ? "sort" : null)}
            containerSx={{
              borderRadius: "4px",
            }}
          />
          <CustomDateRangePicker
            fromDate={from}
            toDate={to}
            setFromDate={setFrom}
            setToDate={setTo}
            placeholder="Select date range"
            disableFuture
            showReset
            sx={{
              height: "38px",
              width: "220px",
            }}
          />
        </Box>

        <ExportButton onClick={handleExport}>
          <img src={downloadCloud} alt="export" width={18} height={18} />
          <FilterExportText>Download</FilterExportText>
        </ExportButton>
      </FiltersRight>
    </FiltersSection>
  );
};

export default CreditNotesFilters;
